const React = require('react');

const Config = {
  default: '',
  list: {},
};

const htmlPattern = /<\/?[a-z][\s\S]*>/i;

function getStoredLanguage() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return '';
  }

  return (
    window.sessionStorage.getItem('changedlang') ||
    window.sessionStorage.getItem('lang') ||
    ''
  );
}

function getActiveLanguage() {
  const storedLanguage = getStoredLanguage();

  if (storedLanguage && Config.list[storedLanguage]) {
    return storedLanguage;
  }

  if (Config.default && Config.list[Config.default]) {
    return Config.default;
  }

  return Object.keys(Config.list)[0] || '';
}

function getLanguageFile() {
  const activeLanguage = getActiveLanguage();
  const entry = Config.list[activeLanguage];

  if (!entry || !entry.file) {
    return {};
  }

  return entry.file.default || entry.file;
}

function getTranslation(text) {
  const file = getLanguageFile();
  return file[text] || text;
}

function renderTranslation(text) {
  if (typeof text !== 'string') {
    return text;
  }

  if (htmlPattern.test(text)) {
    return React.createElement('span', {
      dangerouslySetInnerHTML: { __html: text },
    });
  }

  return text;
}

function Translator({ children }) {
  return React.createElement(React.Fragment, null, children);
}

function T(text) {
  return renderTranslation(getTranslation(text));
}

function TF(text, ...args) {
  const translated = getTranslation(text);

  if (typeof translated !== 'string') {
    return translated;
  }

  return translated.replace(/{(\d+)}/g, (match, index) => {
    const value = args[Number(index)];
    return value === undefined ? match : value;
  });
}

function LanguageList({ Language }) {
  React.useEffect(() => {
    if (typeof window !== 'undefined' && window.sessionStorage && Language) {
      window.sessionStorage.setItem('lang', Language);
    }
  }, [Language]);

  return null;
}

module.exports = {
  Config,
  LanguageList,
  T,
  TF,
  Translator,
};
